<div class="header-navigation-back">
  <mat-icon (click)="onNavigateBack()">arrow_back</mat-icon>
  <span class="title">Trip Details</span>
  @if (!shipmentInactive) {
    <button  mat-icon-button class="margin-xs" (click)="onOpenActionSheet()">
      <mat-icon aria-hidden="false" aria-label="Shipment actions">more_horiz</mat-icon>
    </button>
  }
</div>
@if (status) {
  <app-status-banner [status]="status" class="padding-bottom-xlg">
    @if (status.messageType === 'cancelledReason') {
      <p>
        {{ cancelledStatus }} <br />
        <span class="cancelledLoad"><b>Reason: </b>{{ cancelledReason }}</span>
      </p>
    }
  </app-status-banner>
}
<div  class="mat-error margin-sm">
  {{ errorMessage }}
</div>

@if (loading) {
  <app-loading-gif></app-loading-gif>
}
@if (shipment && !loading) {
  <app-shipment-item-details
    [shipment]="shipment"
    [driverId]="driverId"
    class="padding-top-sm"
    >
  </app-shipment-item-details>
}
<app-actions [actions]="actions" class="margin-top-lg" [ngClass]="showNavBar ? 'fixed-bottom' : ''"></app-actions>
